import { useLocation , Navigate , Outlet } from "react-router";
import { useRoleBasedPermissionsListingQuery } from "services/roles-management/permissions/permissions-api";
import { get_user } from "./functions";
import Loader from "ui-component/Loader";

export const useHasPermissions = (permission) => {
    const { data: userPermissions, isLoading } = useRoleBasedPermissionsListingQuery();
  
    const hasPermission = !isLoading && 
                          (userPermissions?.role?.name === 'Super Admin' || 
                           userPermissions?.role?.permissions?.includes(permission));
    return hasPermission;
  };
  

export const HasPermission = (requiredPermission) => {
     
    const { data: userPermissions, isLoading } = useRoleBasedPermissionsListingQuery();

    const location = useLocation();
    // const permission = (userPermissions?.name === 'Super Admin' || userPermissions?.permissions?.includes(requiredPermission.data))
    return isLoading ? <Loader  /> :   (userPermissions?.role?.name === 'Super Admin' || userPermissions?.role?.permissions?.includes(requiredPermission.data)) ? requiredPermission.children || <Outlet /> : <Navigate to="/404" state={{ from: location }} replace />
  }